<template>
  <div id="app" :class="{ 'pc': !isM }">
    <router-view></router-view>
    <BottomMenu />
    <van-popup v-model="loginPop" position="bottom">
      <component :is="`${region}Login`" />
    </van-popup>
    <RechargeCode />
    <div class="load_pop" v-if="loadPop">
      <van-loading type="spinner" />
    </div>
    <SelectGame ref="selectGame" />
  </div>
</template>

<script>
import { setUrlParams } from '@/utils/webLoginSorage'
import { userLogin, homeGameList, homeGameListNL, systemShareLogin } from '@/api'
import zlLogin from './components/login/zlLogin.vue'
import BottomMenu from './components/BottomMenu.vue'
import RechargeCode from '@/components/RechargeCode.vue'
import { mapState } from 'vuex'
import { Popup, Loading, Dialog } from 'vant'
import SelectGame from '@/components/SelectGame.vue'
export default {
  name: 'App',
  components: {
    BottomMenu,
    zlLogin,
    [Popup.name]: Popup,
    [Loading.name]: Loading,
    RechargeCode,
    SelectGame
  },
  computed: {
    ...mapState(['region', 'loginStatus', 'currentGameAppkey', 'loadPop', 'isM', 'wxProgram', 'inGame'])
  },
  data() {
    return {
      loginPop: false
    }
  },
  watch: {
    loginStatus: function () {
      if (this.loginStatus) {
        this.loginPop = false
        if (!localStorage.getItem('zlVipCurrentGameAppkey')) {//没有选择项目,默认选取用户游戏列表的第一个
          //针对部分老账号存在未上架会员中心的老项目特殊处理（后加功能补丁，最初版本未考虑到这种情况，后续版本，在登录处已做处理）
          let userList = JSON.parse(localStorage.getItem('zlVipUserList'))
          userList.sort((a, b) => {//按最新创建的游戏账户排序
            return new Date(b.create.replace(/-/g, '/')).getTime() - new Date(a.create.replace(/-/g, '/')).getTime()
          })
          localStorage.setItem('zlVipUserList', JSON.stringify(userList))
          //补丁部分结束
          this.$store.commit('changeCurrentGameAppkey', JSON.parse(localStorage.getItem('zlVipUserList'))[0].appkey)
          //改为手动选择游戏
          this.$refs.selectGame.openSelectGame()
        } else {
          new Tracker({
            type: 'owsevent', // apevent-活动打点   owsevent-官网打点
            appkey: this.currentGameAppkey, // 应用标识，用来区分埋点数据中的应用
            lpid: 'vipcenter_zlongame_cn',  // 页面唯一标识
            zone: 'cn', // cn-国内  tw-台湾 sg-新加坡 kr-韩国 us-欧美 jp-日本 sea-东南亚 vn-越南 埋点上报的后端接口
            enableTrackerKey: true,
            useClass: true, // 使用类名来标识domClick
            enableHeatMapTracker: false, // 是否开启热力图自动上报
            enableLoadTracker: true, // 是否开启页面加载自动上报，
            enableHistoryTracker: false, // 是否开启页面history变化自动上报
            enableHashTracker: false, // 是否开启页面hash变化自动上报
          })
        }
        let params = {}
        if (this.$getQueryParam('loginCode')) {//用户从小程序登录，获取wx.login的code,订阅消息需要
          params.code = this.$getQueryParam('loginCode')
        }
        userLogin(params).then(res => {
          if (res.data.code == 0) {
            this.$store.commit('changeAccountInfo', res.data.data)
            if (res.headers?.sid) {
              localStorage.setItem('zlVipSid', res.headers.sid)
            }
            this.init()
          } else {
            this.$requestFail(res.data.code)
          }
        })
      }
    },
    '$route.path': function (newVal) {
      if (newVal == '/') {
        this.$nextTick(() => {
          this.$eventBus.$emit('triggerSignInInit')//手动触发签到初始化
        })
      }
    }
  },
  async created() {
    // 判断是否为iOS设备
    const ua = navigator.userAgent.toLowerCase();
    this.$store.commit('changeIsIOS', /iphone|ipad|ipod|mac|safari/.test(ua))
    if (this.$getQueryParam('pdseq')) {
      setUrlParams()
      return
    }
    if (this.$getQueryParam('userid')) {
      this.inGameInit()
    }
    if (!localStorage.getItem('zlVipSignature') && localStorage.getItem('zlVipUserList') && !this.inGame) {//老版本用户，需要重新获取签名,之后版本可删除
      this.addSignature()
      return
    }
    if (!this.inGame) {//不在游戏内时，才检查是否过期
      this.checkExpire()
    }
    if (localStorage.getItem('zlVipAccountId')) {//此处不可被异步阻断，否则会导致组件内created时登录状态为0，从而不发送请求
      if (JSON.parse(localStorage.getItem('zlVipUserList')).length == 0) {//用户未注册当前游戏，小程序一键登录记住了缓存导致页面异常，需要清除登录状态( 后续可以删除)
        localStorage.clear()
        window.location.href = window.location.href.split('?')[0].split('#')[0]
        return
      }
      this.$store.commit('changeLoginStatus', 1)
    }
    await this.getWxProgram()
    if (!localStorage.getItem('zlVipAccountId')) {
      //未登录状态下，只有小程序选择输入手机号登录时(无getLogin参数)，小程序控制H5弹出登录弹窗
      if (this.wxProgram && !this.$getQueryParam('getLogin')) {
        this.loginPop = true
      }
      this.initNL()
    }
    this.toPage()
    this.$eventBus.$on('refreshLogin', (val) => {
      this.userChangeGameLogin(val)
    })
  },
  methods: {
    getLoginPop() {
      this.loginPop = true
    },
    toPage() {
      //便于小程序初始化，无需后退两次
      if (!this.loginStatus) {
        this.$router.replace({ path: '/' }).catch(err => { });
      }
      // let hashUrl = location.hash.split('#')[1].replace(/\//g, '')
      // console.log(hashUrl)
      // if (hashUrl) {
      //   this.$nextTick(() => {
      //     this.$router.replace({ path: hashUrl })
      //   })
      // }

    },
    userChangeGameLogin(val) {
      userLogin().then(res => {
        if (res.data.code == 0) {
          this.$store.commit('changeAccountInfo', res.data.data)
          if (res.headers?.sid) {
            localStorage.setItem('zlVipSid', res.headers.sid)
          }
          if (val == 'sign') {//只需要触发一次即可，后续游戏信息已发生改变，不会出现错拿初始化游戏信息的情况（切换游戏登录和签到同时请求的情况）
            this.$eventBus.$emit('triggerSignInInit')//手动触发签到初始化
          }
          switch (this.$route.name) {
            case 'home':
              if (!val) {//防止home下触发userChangeGameLogin，自动跳转gift
                this.$router.push(`/gift`) //首页礼包跳转
              }
              break
            case 'gift':
              this.$eventBus.$emit('refreshLevelGift')
              this.$eventBus.$emit('refreshRoleList')
              break
            case 'integral':
              this.$eventBus.$emit('refreshIntegralMallList')
              this.$eventBus.$emit('refreshRoleList')
              break
          }
        } else {
          this.$requestFail(res.data.code)
        }
      })
    },
    init() {//获取会员中心游戏列表
      homeGameList().then(res => {
        if (res.data.code === 0) {
          res.data.data.forEach(item => {
            item.itemIcons = JSON.parse(item.itemIcons)
          })
          this.$store.commit('changeGameList', res.data.data)
          if (res.data.data.findIndex(item => item.appKey == this.currentGameAppkey) != -1) { //如果当前选中游戏(用户游戏列表中)存在会员中心配置的游戏，则不进行自动切换登录
            this.$eventBus.$emit('triggerSignInInit')//手动触发签到初始化，防止自动切换游戏时，使用初始的游戏的信息请求
            return
          }
          //userLogin登录默认选中的游戏不为会员中心配置的游戏时，自动切换至会员中心配置的游戏登录
          let realIndex = -1
          res.data.data.some((item, index) => { //遍历用户游戏列表是否存在会员中心配置的游戏
            if (JSON.parse(localStorage.getItem('zlVipUserList')).findIndex(itemChild => itemChild.appkey == item.appKey) != -1) {
              realIndex = index
            }
            return realIndex != -1; // 为true时，中断循环，找到用户游戏列表中存在会员中心配置的游戏
          })
          if (realIndex != -1) {//自动切换至用户游戏列表中第一个存在于会员中心配置中的游戏登录
            this.$store.commit('changeCurrentGameAppkey', res.data.data[realIndex].appKey)
            this.userChangeGameLogin('sign')
          } else {//用户游戏列表中不存在会员中心配置的游戏时,默认选取会员中心配置的游戏列表的第一个
            this.$store.commit('changeCurrentGameAppkey', res.data.data[0].appKey)
            this.userChangeGameLogin('sign')
          }
        } else {
          this.$requestFail(res.data.code)
        }
      })
    },
    initNL() {//未登录状态下获取会员中心游戏列表
      homeGameListNL().then(res => {
        if (res.data.code === 0) {
          res.data.data.forEach(item => {
            item.itemIcons = JSON.parse(item.itemIcons)
          })
          this.$store.commit('changeGameList', res.data.data)
          if (res.data.data.findIndex(item => item.appKey == this.currentGameAppkey) === -1) {
            //当前 appKey 不在列表中，默认切换至第一个
            this.$store.commit('changeCurrentGameAppkey', res.data.data[0].appKey)
          }
        } else {
          this.$requestFail(res.data.code)
        }
      })
    },
    getWxProgram() {
      return new Promise((resolve, reject) => {
        let _this = this
        // 获取当前环境
        const ua = navigator.userAgent.toLowerCase();
        if (
          ua.match(/MicroMessenger/i) &&
          ua.match(/MicroMessenger/i)[0] == 'micromessenger'
        ) {
          wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
              // 在小程序环境内
              _this.$store.commit('changeWxProgram', true);
            }
            resolve()
          });
        } else {
          resolve()
        }
      })
    },
    checkExpire() {
      if (localStorage.getItem('zlVipExpire')) {
        if (localStorage.getItem('zlVipExpire') != 0) {
          let expire = parseInt(localStorage.getItem('zlVipExpire'))
          let now = parseInt(+new Date() / 1000)
          if (now > expire) {
            Dialog.alert({
              title: this.$t('tip'),
              message: this.$t('10112502')
            }).then(() => {
              localStorage.clear()
              window.location.reload()
            })
          }
        }
      }
    },
    inGameInit() {
      this.$store.commit('changeInGame', true)
      this.$store.commit('changeCurrentGameAppkey', this.$getQueryParam('appkey'))
      let userid = this.$getQueryParam('userid')
      if (userid.startsWith("8")) {//userid截取
        userid = userid.substring(14);
      } else if (userid.startsWith("9")) {
        userid = userid.substring(15);
      } else {
        userid = userid.substring(12);
      }
      if (userid == JSON.parse(localStorage.getItem('zlVipUserList'))?.[0]?.userid) {//防止陷入重复刷新，只有切换游戏账号或首次登入时才往下执行业务登录
        if (localStorage.getItem('zlVipUserList')) {
          this.$router.push({ path: '/gift' })
        }
        return
      }
      localStorage.setItem('zlVipAccountId', userid)//游戏内嵌，调MP接口，暂时将userid设置为accid
      localStorage.setItem('zlVipUserList', JSON.stringify([{
        userid: userid,
        token: this.$getQueryParam('token'),
        appkey: this.$getQueryParam('appkey'),
        device: this.$getQueryParam('device')
      }]))
      userLogin().then(res => {
        if (res.data.code == 0) {
          localStorage.setItem('zlVipAccountId', res.data.data.accId)
          setTimeout(() => {//部分模拟器，需要延迟执行，否则会导致localStorage.setItem('zlVipAccountId', res.data.data.accId)执行失败
            location.reload()
          }, 100)
        } else {
          this.$requestFail(res.data.code)
        }
      })
    },
    addSignature() {
      let params = {}
      let userList = JSON.parse(localStorage.getItem('zlVipUserList'))
      let timestamp = parseInt(+new Date() / 1000)
      let pdsign = this.$md5(timestamp + this.$md5(localStorage.getItem('zlVipAccountId') + userList[0].appkey.toString()).toLowerCase() + userList[0].userid + 'Bejz1R1WE3rUhJUf').toLowerCase()
      params = {
        pdseq: '',
        token: userList[0].token,
        timestamp: timestamp,
        pdsign: pdsign
      }
      systemShareLogin(params).then(res => {
        localStorage.clear()
        if (res.data.info == 10118308) {
          localStorage.setItem('zlVipAccountId', res.data.data.accountid)
          localStorage.setItem('zlVipUserList', JSON.stringify(res.data.data.userlist))
          localStorage.setItem('zlVipSignature', res.data.data.signature)
          localStorage.setItem('zlVipExpire', res.data.data.expire)
          window.location.reload()
        } else {
          Dialog.alert({
            message: `登录信息已过期，请重新登录`,
          }).then(() => {
            // on close
            window.location.reload()
          });
        }
      })
    },
  },
  mounted() { },
  beforeDestroy() {
    this.$eventBus.$off('refreshLogin')
  }
}
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}

#app {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #F9F9F9;

  .load_pop {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
  }
}

.pc#app {
  width: 7.5rem;
  height: 16.5rem;
  overflow: hidden;
}

.pc .van-popup {
  display: flex;
  flex-direction: column;
  align-items: center;

  .popup_box {
    width: 7.5rem;
    left: unset;
  }
}

body {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
